import { GenderDistributionCompare } from "app/pages/website-analysis/demographicsUserBased/genderDistribution/GenderDistributionCompare";
import { AgeDistributionCompare } from "app/pages/website-analysis/demographicsUserBased/ageDistribution/AgeDistributionCompare";
import { useState, useEffect, useMemo } from "react";
import type { IRawData } from "app/pages/website-analysis/demographicsUserBased/utils/fetchData";
import { fetchData, getExcelLink } from "app/pages/website-analysis/demographicsUserBased/utils/fetchData";
import { parseRawAgeRations } from "app/pages/website-analysis/demographicsUserBased/utils/parseRawAgeRations";
import { TrafficAndEngagementTable } from "app/pages/website-analysis/demographicsUserBased/trafficAndEngagmentTable/TrafficAndEngagementTable";
import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { sortRawDataAsSelectedSites } from "app/pages/website-analysis/demographicsUserBased/utils/sortRawDataAsSelectedSites";

export const DemographicsUserBasedCompare = () => {
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [rawData, setRawData] = useState<IRawData>({});
    useEffect(() => {
        setIsLoading(true);
        fetchData()
            .then(setRawData)
            .finally(() => setIsLoading(false));
    }, []);
    const sortedRawData = useMemo(() => {
        const sortedRawData = sortRawDataAsSelectedSites(rawData);
        return sortedRawData;
    }, [rawData]);
    const ageDistributionData = Object.keys(sortedRawData).reduce((result, domain) => {
        return { ...result, [domain]: parseRawAgeRations(sortedRawData[domain].AgeRatios) };
    }, {});

    const genderDistributionData = Object.keys(sortedRawData).reduce((result, domain) => {
        const femalePercentage = sortedRawData[domain].FemalesRatio * 100;
        return {
            ...result,
            [domain]: {
                Female: femalePercentage,
                Male: 100 - femalePercentage,
            },
        };
    }, {});

    const downloadExcelUrl = useMemo(() => getExcelLink(), []);

    return (
        <FlexColumn gap={"20px"}>
            <div>
                <GenderDistributionCompare
                    isLoading={isLoading}
                    genderDistributionData={genderDistributionData}
                    downloadExcelUrl={downloadExcelUrl}
                />
                <AgeDistributionCompare
                    ageDistributionData={ageDistributionData}
                    isLoading={isLoading}
                    downloadExcelUrl={downloadExcelUrl}
                />
            </div>
            <TrafficAndEngagementTable />
        </FlexColumn>
    );
};
